"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cuidRestore = exports.cuidFlush = exports.useCuid = void 0;
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const env_1 = require("../../env");
let cuids = [];
function getCuid() {
    var _a;
    cuidRestore();
    const val = env_1.IS_SERVER ? (0, utils_1.cuid)() : (_a = cuids.shift()) !== null && _a !== void 0 ? _a : (0, utils_1.cuid)();
    if (env_1.IS_SERVER) {
        cuids.push(val);
    }
    return val;
}
function useCuid() {
    const cuidRef = (0, react_1.useRef)('');
    if (!cuidRef.current) {
        cuidRef.current = getCuid();
    }
    return cuidRef.current;
}
exports.useCuid = useCuid;
function cuidFlush() {
    const curr = cuids;
    cuids = [];
    return curr;
}
exports.cuidFlush = cuidFlush;
function cuidRestore() {
    if (typeof window !== 'undefined' && window.__COMPONENT_IDS__) {
        cuids = window.__COMPONENT_IDS__;
        delete window.__COMPONENT_IDS__;
    }
}
exports.cuidRestore = cuidRestore;
